import script from "./total-workloads-chart-controller.vue?vue&type=script&setup=true&lang=ts"
export * from "./total-workloads-chart-controller.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__